import React from 'react';
import Helmet from 'react-helmet';

function SEO({
  title,
  seo
}) {
  return /*#__PURE__*/React.createElement(Helmet, {
    htmlAttributes: {
      lang: seo.lang
    },
    title: title,
    titleTemplate: "".concat(title, " | ").concat(seo.siteTitle),
    meta: [{
      name: "description",
      content: seo.description
    }, {
      property: "og:title",
      content: title
    }, {
      property: "og:description",
      content: seo.description
    }, {
      property: "og:type",
      content: "website"
    }, {
      name: "twitter:card",
      content: "summary_large_image"
    }, {
      name: "twitter:creator",
      content: seo.author
    }, {
      name: "twitter:title",
      content: "".concat(title, " | ").concat(seo.siteTitle)
    }, {
      name: "twitter:description",
      content: seo.description
    }, {
      name: "twitter:image",
      content: seo.image
    }]
  });
}

SEO.displayName = 'SEO';
export default SEO;